import AuthUITemplate from "./AuthUI";
import Button from "../../components/common/Button";
import { Link } from "react-router-dom";
import { useLogin } from "react-redux-django-auth";
import GoogleAuthHandler from "./GoogleAuthHandler";
import Input from "../../components/common/Input";
import { Mail, Lock } from "lucide-react";

const LogIn = () => {
  // Initial Data
  const initialFormData = {
    email: "",
    password: "",
  };

  const { error, formData, loading, onChange, onSubmit } = useLogin(
    initialFormData,
    null,
  );

  return (
    <AuthUITemplate title="Welcome Back" errorMsg={error}>
      <form className="cht-space-y-4" onSubmit={(e) => onSubmit(e)}>
        {/* Email Field */}
        <Input
          label="Email Address"
          labelClassName="cht-text-[10px] cht-font-black cht-text-white/70 cht-uppercase cht-tracking-widest"
          type="email"
          id="email"
          name="email"
          placeholder="name@company.com"
          leftIcon={<Mail size={18} />}
          value={formData.email}
          onChange={(e: any) => onChange(e)}
          required
        />

        {/* Password Field */}
        <Input
          label="Password"
          labelClassName="cht-text-[10px] cht-font-black cht-text-white/70 cht-uppercase cht-tracking-widest"
          subLabel={
            <Link
              to="/reset-password"
              className="cht-text-[10px] cht-font-black cht-text-white/60 hover:cht-text-white cht-uppercase cht-tracking-widest cht-transition-colors"
            >
              Forgot password?
            </Link>
          }
          type="password"
          id="password"
          name="password"
          placeholder="••••••••"
          leftIcon={<Lock size={18} />}
          value={formData.password}
          onChange={(e: any) => onChange(e)}
          required
        />

        {/* Submit Button */}
        <Button
          type="submit"
          variant="primary"
          size="lg"
          fullWidth
          isLoading={loading}
          disabled={loading}
          className="cht-w-full cht-py-4 cht-uppercase cht-tracking-widest cht-text-xs cht-rounded-2xl"
        >
          Sign In
        </Button>
      </form>

      {/* Divider */}
      <div className="cht-relative cht-my-8 cht-flex cht-items-center cht-justify-center">
        <div className="cht-absolute cht-inset-0 cht-flex cht-items-center">
          <div className="cht-w-full cht-border-t cht-border-white/10"></div>
        </div>
        <span className="cht-relative cht-bg-transparent cht-px-4 cht-text-[10px] cht-font-black cht-text-white/40 cht-uppercase cht-tracking-widest">
          or
        </span>
      </div>

      {/* Google Login */}
      <div className="cht-space-y-6">
        <GoogleAuthHandler />

        <p className="cht-text-center cht-text-xs cht-font-medium cht-text-white/60">
          Are you new?{" "}
          <Link
            to="/create-account"
            className="cht-text-white cht-font-black hover:cht-underline cht-ml-1"
          >
            Create an Account
          </Link>
        </p>
      </div>
    </AuthUITemplate>
  );
};

export default LogIn;
